import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const mainConfig = {
  apiKey: import.meta.env.VITE_API_KEY,
  authDomain: import.meta.env.VITE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_ID,
  measurementId: import.meta.env.VITE_MEASUREMENT_ID,
};

export const firebaseApp = initializeApp(mainConfig, 'modular');
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const functions = getFunctions(firebaseApp);
export const storage = getStorage(firebaseApp);
export const patientStorage = getStorage(firebaseApp, import.meta.env.VITE_FIREBASE_PATIENT_STORAGE);
export const videoStorage = getStorage(firebaseApp, import.meta.env.VITE_FIREBASE_VIDEO_STORAGE);
export const publicStorage = getStorage(firebaseApp, import.meta.env.VITE_FIREBASE_PUBLIC_STORAGE);
export const backendStorage = getStorage(firebaseApp, import.meta.env.VITE_FIREBASE_BACKEND_STORAGE);

if (location.hostname === 'localhost') {
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
  connectStorageEmulator(patientStorage, '127.0.0.1', 9199);
  connectStorageEmulator(videoStorage, '127.0.0.1', 9199);
  connectStorageEmulator(publicStorage, '127.0.0.1', 9199);
  connectStorageEmulator(backendStorage, '127.0.0.1', 9199);
  connectAuthEmulator(auth, 'http://127.0.0.1:9099');
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
}
